import * as mutationTypes from './mutationTypes'
import initialState from './initialState'
import Vue from 'vue'
import { PASSWORD_CHANGE_REQUIRED } from '@api/Statuses'

export default {
  [ mutationTypes.SET_INITIAL_STATE ] (state) {
    let initializedState = initialState()
    Object.keys(initializedState).forEach(key => {
      Vue.set(state, key, initializedState[key])
    })
  },

  [ mutationTypes.LOG_USER_IN ] (state) {
    Vue.set(state, 'loggedIn', true)
  },

  [ mutationTypes.LOG_USER_OUT ] (state) {
    Vue.set(state, 'loggedIn', false)
  },

  [ mutationTypes.SET_LOGIN_DETAILS ] (state, loginResponse) {
    // console.log('SET LOGIN DETAILS mutation', loginResponse);
    state.authMessage = loginResponse.message || loginResponse.userMessage
    state.authValue = loginResponse.userValue
    state.termsAndConditionsAccepted = loginResponse.termsAndConditionsAccepted
    state.smsReminder = loginResponse.smsReminder
    state.smsEnabled = loginResponse.smsEnabled
    state.authStatus = loginResponse.status
    state.isSsoUser = loginResponse.isSsoUser || false
    // todo we may want to handle more statuses here
    if (loginResponse.status !== PASSWORD_CHANGE_REQUIRED) {
      state.loggedIn = true
      state.userId = loginResponse.userId
      state.userFirstName = loginResponse.firstName
      state.userLastName = loginResponse.lastName

      if (loginResponse.role) {
        state.securityChanged = loginResponse.role.securityChanged
        state.userType = loginResponse.role.userType
        state.userRole = loginResponse.role
        state.accountType = loginResponse.role.accountType
        state.paperlessSelectionRequired = loginResponse.role.paperlessSelectionRequired
        state.subGroupAccess = loginResponse.role.subGroupAccess;
        if(loginResponse.role.minimumAccess) {
          state.minimumAccess = loginResponse.role.minimumAccess;
        }
      }
    }
  },

  [mutationTypes.ACCEPTED_TERMS](state, payload) {
    state.termsAndConditionsAccepted = payload;
  },

  [ mutationTypes.SET_USER_ID ] (state, userId) {
    state.userId = userId
  },

  [ mutationTypes.INITIALIZE_TOKEN_VERIFICATION ] (state) {
    state.authError = false
    state.tokenError = false
    state.verifyingToken = true
    state.authMessage = ''
  },

  [ mutationTypes.SET_VERIFYING_TOKEN ] (state, verifyingToken) {
    state.verifyingToken = verifyingToken
  },

  [ mutationTypes.SET_AUTH_ERROR ] (state, authError) {
    state.authError = authError
  },

  [ mutationTypes.SET_AUTH_MESSAGE ] (state, authMessage) {
    state.authMessage = authMessage
  },

  [ mutationTypes.SET_AUTH_VALUE ] (state, authValue) {
    state.authValue = authValue
  },

  [ mutationTypes.SET_RESETTING_PASSWORD ] (state, resettingPassword) {
    state.resettingPassword = resettingPassword
  },

  [ mutationTypes.SET_UPDATING_PASSWORD ] (state, updatingPassword) {
    state.updatingPassword = updatingPassword
  },

  [ mutationTypes.SET_REQUESTING_NEW_TOKEN ] (state, requestingNewToken) {
    state.requestingNewToken = requestingNewToken
  },

  [ mutationTypes.SET_TOKEN_USER_MESSAGE ] (state, userMessage) {
    state.tokenUserMessage = userMessage
  },

  [ mutationTypes.SET_LOGGING_IN ] (state, loggingIn) {
    state.loggingIn = loggingIn
  },

  [ mutationTypes.SET_AUTH_STATUS ] (state, status) {
    state.authStatus = status
  },

  [ mutationTypes.AUTH_FAILED ] (state, errorResponse) {
    state.authErrorMessage = errorResponse.userMessage || errorResponse.message
    state.authFailed = true
    state.loggingIn = false

    if (!state.previousAttemptLoginUserId) {
      state.previousAttemptLoginUserId = state.userId
    }
    if (state.userId === state.previousAttemptLoginUserId) {
      state.lockoutWarningCounter = state.lockoutWarningCounter + 1
    } else {
      state.lockoutWarningCounter = 1
      state.previousAttemptLoginUserId = state.userId
    }
  },

  [ mutationTypes.RESET_LOGIN_MESSAGES ] (state) {
    state.authErrorMessage = ''
    state.authStatus = ''
    state.authMessage = ''
    state.authError = false
    state.tokenUserMessage = ''
  },

  [ mutationTypes.SET_RESETTING_INCORRECT_LOGIN_COUNTER ] (state) {
    state.lockoutWarningCounter = 0
    state.previousAttemptLoginUserId = ''
  },

  [ mutationTypes.SET_ISSUING_RESET_PASSWORD_INSTRUCTIONS ] (state, issuingResetPasswordInstructions) {
    state.issuingResetPasswordInstructions = issuingResetPasswordInstructions
  },

  [ mutationTypes.SET_ISSUING_NEW_REGISTRATION_EMAIL ] (state, issuingNewRegistrationEmail) {
    state.issuingNewRegistrationEmail = issuingNewRegistrationEmail
  },

  [ mutationTypes.SET_RESET_PASSWORD_MESSAGE ] (state, resetPasswordMessage) {
    state.resetPasswordMessage = resetPasswordMessage
  },

  [ mutationTypes.SET_TOKEN_ERROR ] (state, tokenError) {
    state.tokenError = tokenError // true or false
  },

  [mutationTypes.SET_SSO_AUTH_ERROR] (state, authError) {
    state.ssoAuthError = authError
    state.ssoAuthErrorMessage = 'We are unable to identify you as an authorized user. Please contact your account representative'
  },

  [mutationTypes.SET_CLOSE_SMS_PROMPT](state, payload) {
    state.closeSmsPrompt = payload;
  },

  SAVE_PASSWORD(state, payload) {
    state.password = payload
  }
}
